import { render, staticRenderFns } from "./relatorios_vendas.vue?vue&type=template&id=2c8d3056&scoped=true&"
import script from "./relatorios_vendas.vue?vue&type=script&lang=js&"
export * from "./relatorios_vendas.vue?vue&type=script&lang=js&"
import style0 from "./relatorios_vendas.vue?vue&type=style&index=0&id=2c8d3056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d3056",
  null
  
)

export default component.exports